<template>
  <b-container fluid>
    <backlink />
    <h1>Expéditions</h1>

    <AdminTable :config="config" :options="options" :items_provider="itemsProvider">
      <template slot="status" slot-scope="{ data }">
        <b-badge variant="primary">{{ data.value }}</b-badge>
      </template>
      <template slot="refs_and_products" slot-scope="{ data }">
        <span v-html="data.value"></span>
      </template>
      <template slot="group_slugs" slot-scope="{ data }">
        <div style="width: 75px">
          <b-badge
            v-if="data.value.includes('outillage')"
            variant="outillage"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge
            v-else
            variant="transparent"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text"
          >
            &nbsp;
          </b-badge>
          <b-badge
            v-if="data.value.includes('instruments')"
            variant="instruments"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('instruments').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
          <b-badge
            v-else
            variant="transparent"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('outillage').text"
          >
            &nbsp;
          </b-badge>
          <b-badge
            v-if="data.value.includes('service_et_logistique')"
            variant="service_et_logistique"
            class="circle float-left"
            v-b-tooltip.hover
            :title="$store.getters['renting_preparation/getGroup']('service_et_logistique').text"
          >
            <i class="fa fa-check"></i>
          </b-badge>
        </div>
      </template>
    </AdminTable>
  </b-container>
</template>

<script>
import AdminTable from "@/components/Global/AdminTableSync";
import config from "./config";

export default {
  name: "ShippingList",
  components: {
    AdminTable,
  },
  data() {
    return {};
  },
  computed: {
    // 14.16 : true si l'utilisateur n'a pas d'entrepôt rattaché (accès à tous les entrepôts)
    isAllWarehouses: function () {
      return !this.$store.getters["auth/warehouse"];
    },
    // 14.16 : on retire le filtre entrepôt pour les utilisateurs rattachés à un
    // entrepôt (périmètre déjà forcé côté serveur). Seul le champ de filtre est
    // retiré, celui du détail / export porte le même nom et doit rester.
    config: function () {
      if (this.isAllWarehouses) {
        return config;
      }
      return {
        ...config,
        fields: config.fields.filter(
          (field) => !(field.name === "warehouse" && field.extendedFilter)
        ),
      };
    },
    options: function () {
      return {
        status_options: this.$store.getters["status/getByGroup"]("shipping").selectOptions(
          "status_slug",
          "name"
        ),
        // "-- Tout --" ajouté par AdminTableSync, comme pour l'entrepôt
        from_mcs_options: [
          { value: '1', text: "Import MCS" },
          { value: '0', text: "Axiloc" },
        ],
        // 14.16 : options du filtre entrepôt ("-- Tout --" ajouté par AdminTableSync)
        warehouse_options: (this.$store.getters["warehouse/getAll"] || []).map((w) => ({
          value: w.id,
          text: w.internal_code + " - " + w.name,
        })),
      };
    },
  },
  mounted() {
    // 14.16 : entrepôts pour le filtre (seulement utile en accès-tout)
    if (this.isAllWarehouses) {
      this.$store.dispatch("warehouse/getAll");
    }
  },
  methods: {
    /**
     * Fourni les données à AdminTableSync. Cette méthode est appelée à chaque 
     * rafraichissement de la liste
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {object}        {
                                  total: Nombre total de résultats,
                                  items: Items à afficher
                                }
     */
    itemsProvider(ctx) {
      var self = this;
      return new Promise(function (resolve, reject) {
        self.$http
          .get(process.env.BACK_API_URL + "shipping", {
            params: {
              page: ctx.currentPage,
              limit: ctx.perPage,
              sortBy: ctx.sortBy,
              sortDesc: ctx.sortDesc ? "DESC" : "ASC",
              search: ctx.filter,
              statusSlug: ctx.extended_filters_model.status,
              start_shipping_date: ctx.extended_filters_model.shipping_date.start
                ? self.$moment(ctx.extended_filters_model.shipping_date.start).format("YYYY-MM-DD")
                : null,
              end_shipping_date: ctx.extended_filters_model.shipping_date.end
                ? self.$moment(ctx.extended_filters_model.shipping_date.end).format("YYYY-MM-DD")
                : null,
              // 14.16 : filtre entrepôt de l'expédition (ignoré côté serveur si l'user est scopé)
              warehouse: ctx.extended_filters_model.warehouse,
              from_mcs: ctx.extended_filters_model.from_mcs,
            },
          })
          .then((response) => {
            resolve({
              total: response.data.total,
              page: parseInt(response.data.page),
              items: response.data.shippings || [],
            });
          })
          .catch((error) => {
            self.$toastr.error("Le chargement de la liste a échoué");
            self.inGenerating = false;
          });
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Shipping/ShippingList.vue